export function iconFillVariant(icon: string) {
  if (icon.startsWith("ph:")) return `${icon}-duotone`;

  return icon;
}
